import { render, staticRenderFns } from "./krasAction.vue?vue&type=template&id=8a3dbd72"
import script from "./krasAction.vue?vue&type=script&lang=js"
export * from "./krasAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a3dbd72')) {
      api.createRecord('8a3dbd72', component.options)
    } else {
      api.reload('8a3dbd72', component.options)
    }
    module.hot.accept("./krasAction.vue?vue&type=template&id=8a3dbd72", function () {
      api.rerender('8a3dbd72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/kras/action/krasAction.vue"
export default component.exports